import Vue from 'vue';
import Router from 'vue-router';
import routerInfo from './router';
import App from './App.vue';
// import { install } from '@/i18n';
import { rem, vueTap, initReport, request, util, setBiHottagReady } from '@tencent/ppd-base-libs';
import axios from 'axios';
import { initMtnBiReport, MtnBiReportPageType, MtnBiReportReportType } from '@tencent/wphk-components-mtn-bi-report';

// Vue.use(install);
// 处理路由信息
Vue.use(Router);
const router = new Router(routerInfo);

request.init(axios);

// 让elk立马上报，不延时
util.setReportReady();
setBiHottagReady();

initReport({
  router,
  // @ts-ignore
  appEnv: process.env.VUE_APP_ENV,
  // @ts-ignore
  business: process.env.VUE_APP_PKGNAME,  // 区分业务，用于elk
  isReportPageStayedTime: true, // 是否上报页面停留时间
  sentry: {
    dsn: '',
    // webpack变异全局变量
    release: process.env.VUE_APP_SENTRY_VERSION,
  },
  bi: {
    noAdtag: true,
    reportNeedLogin: false,
  },
}, Vue);

initMtnBiReport({
  channel: process.env.VUE_APP_PKGNAME,
  pageType: MtnBiReportPageType.RedirectPage,
  reportType: MtnBiReportReportType.SendBeacon,
});

// 开启rem布局
rem();
// 开启vtap
Vue.use(vueTap);

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
